import { render, staticRenderFns } from "./GuidelinesDetailStandards.vue?vue&type=template&id=219ba4d0&scoped=true"
import script from "./GuidelinesDetailStandards.vue?vue&type=script&lang=js"
export * from "./GuidelinesDetailStandards.vue?vue&type=script&lang=js"
import style0 from "./GuidelinesDetailStandards.vue?vue&type=style&index=0&id=219ba4d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219ba4d0",
  null
  
)

export default component.exports